module.exports = __webpack_public_path__ + "static/media/purple-step.b6f4f1f9.svg";